import { SVGProps } from 'react';

const GitGraph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0v6m0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6m7-12v18m7-12a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0a9 9 0 0 1-3 6.7"
    />
  </svg>
);
export default GitGraph;
